module.exports = __webpack_public_path__ + "static/media/handShakeBlack.73d43e29.svg";